<div class="staff-menu ag-pa-md">
  <h4 class="text-center">
    Staff Menu
    <i
      class="fa fa-times pull-right close-sidenav"
      aria-hidden="true"
      title="Close Staff Menu"
      (click)="closeNav()"
    ></i>
  </h4>
  @if (staffMenuItems) {
    <div style="padding-top: 5px; padding-bottom: 5px">
      <div style="width: inherit; padding: 0; margin: 0">
        @for (sMenus of staffMenuItems; track sMenus) {
          <div>
            <div class="staff-list">
              <div class="header-title" tabindex="0" (agInteract)="toggleMenu(sMenus)">
                {{ sMenus?.label }}
                <span class="header-icon">
                  <i
                    [ngClass]="sMenus.expanded ? 'fa-angle-down' : 'fa-angle-right'"
                    class="fa"
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
              @if (sMenus.expanded) {
                <div class="collapsable">
                  @for (sLinks of sMenus.items; track sLinks) {
                    <ul>
                      <li class="main-items" [ngClass]="sLinks.url ? 'main-link' : 'no-link'">
                        @if (sLinks.url) {
                          <a tabindex="0" (agInteract)="openStaffIframe(sLinks.menuItem)">
                            {{ sLinks.label }}
                          </a>
                        } @else {
                          <span>
                            {{ sLinks.label }}
                          </span>
                        }
                        @for (subitems of sLinks.subItems; track subitems) {
                          <ul>
                            <li class="sub-items">
                              <a tabindex="0" (agInteract)="openStaffIframe(subitems.menuItem)">
                                {{ subitems.label }}
                              </a>
                            </li>
                          </ul>
                        }
                      </li>
                    </ul>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
